import { render, staticRenderFns } from "./sportsRule.vue?vue&type=template&id=6eac03e2&scoped=true"
import script from "./sportsRule.vue?vue&type=script&lang=js"
export * from "./sportsRule.vue?vue&type=script&lang=js"
import style0 from "./sportsRule.vue?vue&type=style&index=0&id=6eac03e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eac03e2",
  null
  
)

export default component.exports